import React from 'react';
import PropTypes from 'prop-types';

import { getTranslation } from 'common/react/utils/translations';
import { TBCRoundTooltip } from './TBCRoundTooltip';

export const FixturesDateHeader = ({ dateKey }) => {
    if (dateKey.startsWith('TBC_')) {
        const parts = dateKey.split('_');

        const roundNumber = parts[1];
        const date = parts[2];

        return (
            <div className="fixtures__tbc-date-wrapper">
                <h2 className="fixtures__date-header">
                    {getTranslation('label.fixtures.tbcRoundStartDate')}{' '}
                    {moment(date, 'YYYYMMDD').format('dddd, D MMMM YYYY')}
                </h2>
                <TBCRoundTooltip roundNumber={roundNumber} />
            </div>
        );
    }

    const label =
        dateKey === 'TBCPC'
            ? getTranslation('label.fixtures.tbc-postponed-cancelled')
            : moment(dateKey, 'YYYYMMDD')
                  // We don't need to adjust timezone here as it was already adjusted when grouping
                  .format('dddd MMMM D');

    return <h2 className="fixtures__date-header">{label}</h2>;
};

FixturesDateHeader.propTypes = {
    dateKey: PropTypes.string.isRequired
};
